import { ReactNode } from 'react';
import cls from 'classnames';

import styles from './FormLabel.module.css';

interface FormLabelProps extends Record<string, unknown> {
  children?: ReactNode;
  className?: string;
  renderBeforeLabelText?: Nullable<() => ReactNode>;
  isFilterInputMetaEmpty?: boolean;
  areFiltersInputMetaActive?: boolean;
}

function FormLabel(props: FormLabelProps) {
  const {
    children = null,
    className = '',
    renderBeforeLabelText = null,
    isFilterInputMetaEmpty = false,
    areFiltersInputMetaActive = false,
  } = props;

  const isFilterInputMetaEmptyClassName = isFilterInputMetaEmpty ? '' : styles.formLabelActiveFilter;
  const areFiltersInputMetaActiveClassName = areFiltersInputMetaActive ? styles.formLabelNonActiveFilter : '';
  const filterItemStyles =
    isFilterInputMetaEmptyClassName === '' ? areFiltersInputMetaActiveClassName : isFilterInputMetaEmptyClassName;

  return (
    <div className={cls(styles.formLabel, className, filterItemStyles)}>
      {renderBeforeLabelText ? renderBeforeLabelText() : null}

      {children}
    </div>
  );
}

export default FormLabel;
